<template>
<v-container>
  <div>
    <p class="headText">Galerie Stock Checker</p>
    <b-nav fill >
      <b-row class="toolbar">
        <router-link class="btn-galerie" tag="b-col" :to="'/'">
          Home</router-link>
        <router-link class="btn-galerie" tag="b-col" v-if="authenticated && cust.Role === 'Admin'" :to="'/customers'">
          Customer</router-link>
        <router-link  class="btn-galerie" tag="b-col" :to="'/collections'"  v-if="authenticated && cust.Role === 'Admin'">
          Collections
        </router-link>
        <b-col v-if="!authenticated" class="btn-galerie"
          id="qsLoginBtn"
          @click="login()">
          Log In
        </b-col>
        <b-col v-if="authenticated" class="btn-galerie"
          id="qsLogoutBtn"
          @click="logout()">
          Log Out
        </b-col>
    </b-row>
  </b-nav>

    <div >
      <router-view
        :auth="auth"
        :authenticated="authenticated"
        :cust="cust">
      </router-view>
    </div>
  </div>
</v-container>
</template>

<script>
import AuthService from './auth/AuthService'
import { mapGetters } from 'vuex'
const auth = new AuthService()

const { login, logout, authenticated, authNotifier, cust } = auth
export default {
  name: 'app',
  computed: {
    ...mapGetters([
    ])
  },
  data () {
    authNotifier.on('authChange', authState => {
      this.authenticated = authState.authenticated
      this.cust = authState.cust
    })
    return {
      auth,
      authenticated,
      cust
    }
  },
  methods: {
    login,
    logout
  },
  created () {
  }
}
</script>

<style>
/* @import '../node_modules/bootstrap/dist/css/bootstrap.css'; */
body{    font-family: "work sans",helvetica,arial,sans-serif;   font-weight: 400!important; margin:0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 1rem;
}
.container{
  max-width: 700px !Important;
}
.toolbar {
  width: 100%;
  margin: 0px;
}
.btn-margin {
  margin-top: 7px
}
.btn-galerie {
  text-align: center;
  padding: 15px 0px;
  cursor: pointer;
  background-color:#d8dfe9;
  margin: 2px;
  border-radius: 2px;
  font-size: 1.5rem;
}
.v-input__slot {
  background-color: #eff2f6 !important;
}
.router-link-active{
  background-color: #eff2f6;
}
.main-body {
  background-color: #fcfcfd !important;
}
.btn-nav {
  text-align: center;
  padding: 15px 0px;
}
.btn-nav a {
  color: black;
  font-size: 110%;
}
.tblStriped tr:nth-child(even){
  background-color: lightgray
}
td, th {
  border: 1px solid #dddddd;
  padding: 8px;
}
.thBtn {
  width: 50px;
}
.tdBtn {
  background-color: white
}
.tbl {
  width: 400px
}
.tickboxes {
  text-align: center;
}
.tblBtn {
  text-align: center;
  width: 75px;
}
.headText {
  font-size: 150%;
  text-align: center;
  padding: 16px 0
}
.navbar-header2 {
  text-align: center;
  max-width: 500px;
  margin: auto
}
h6 {
  text-align: center;
  color: #212529;
}

@media (max-width: 700px) {
  h6 {
    font-size: 1.5rem !important;
  }
  .headText{
    font-size: 100%;
    padding: 0;
    margin-bottom: 0;
  }
  .btn-galerie {
    padding: 8px 0px;
    font-size: 1.5rem
  }
  td ,th {
    padding: 2px 5px;
  }
}
@media (max-width: 600px) {
  h6 {
    font-size: 1.25rem !important;
  }
  .headText{
    font-size: 100%;
    padding: 0;
    margin-bottom: 0;
  }
  .btn-galerie {
    padding: 5px 0px;
    font-size: 1.2rem
  }
  td ,th {
    padding: 1px 3px;
  }
}
</style>
